<template>
  <div>
      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">


                  <ul  class="block-options">

                      <li v-if="flagDisplayChannel===0">
                          <button type="button" @click="toggleDisplayChannel()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayChannel">
                          <button  type="button" @click="toggleDisplayChannel()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>

                <h2 class="block-title" style="font-size:18px" @click="toggleDisplayChannel()"><i class="fa fa-television fa-1x push-5-r "></i>{{channelIndex+1}}:{{actualBundle.channels[channelIndex].ReferenceName}}</h2>

              <div v-if="flagDisplayPowerBar && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable && thisChannelAsDeviceFlag" class="row">
                  <hr></hr>
                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarData5Min" ></relative-power-bar>
                  </div>
                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_001H" ></relative-power-bar>
                  </div>
                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_004H" ></relative-power-bar>
                  </div>
                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_006H" ></relative-power-bar>
                  </div>

                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_012H" ></relative-power-bar>
                  </div>

                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_024H" ></relative-power-bar>
                  </div>

                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_072H" ></relative-power-bar>
                  </div>

                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_168H" ></relative-power-bar>
                  </div>

                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_336H" ></relative-power-bar>
                  </div>

                  <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                    <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_720H" ></relative-power-bar>
                  </div>
              </div>
            </div>

            <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag" class="block-content">
              <div class="row">
                <div v-for = "(attribute ,index) in actualBundle.channels[channelIndex].Attributes">
                  <div v-if="actualBundle.channels[channelIndex].Attributes[index] != 'ND'" class="col-xm-6 col-sm-4 col-md-2">
                    
                    <button  class="btn btn-xs btn-default" type="button"><i class="fa fa-tag fa-1x push-5-r "></i>{{actualBundle.channels[channelIndex].Attributes[index]}}</button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="flagDisplayChannel" class="block-content">
              <spinner  v-if="flagChannelDataIsLoading"></spinner>


              <div v-else class="row">
                <div class="col-xs-12">
                    <!-- Static Labels -->
                    <div class="block">


                      <div v-if="true" class="col-xs-12 items-push">
                    
                          <div class="row">
                            <div class="col-sm-12 col-md-6">
                              <h3 class="font-w300 push measurement-graph-row__title">
                                <img class="measurement-graph-row__icon" width="80px" :src="`appliances/${actualBundle.channels[channelIndex].ChannelData.channelInfo.iconFile}` | s3Image" alt="">
                                {{actualBundle.channels[channelIndex].ChannelData.channelInfo.channelName}}
                              </h3>
                            </div>

                            <div class="col-sm-12 col-md-6">
                              <div v-if="thisChannelAsDeviceFlag" class="form-group align-right">
                                  <label>Online</label> <i v-if="actualBundle.channels[channelIndex].ChannelData.deviceOnline" class="fa fa-toggle-on fa-2x"></i><i v-else class="fa fa-toggle-off fa-2x"></i>
                              </div>

                              
                              <div class="form-group align-right">
                                <div v-if="actualBundle.bundleRights.realTimeMeasurementPanel" class="col-sm-12">
                                  <button  class="btn btn-default" @click="loadCloudLive()" >
                                    <spinner size="small" v-if="flagCloudLiveIsActivating"></spinner>
                                    <i v-else class="fa fa-cloud-download fa-1x push-15-r "></i>Cloud Live</button>
                                </div>
                              </div>
                              
                              
                              <div class="form-group">
                                  <label class="col-xs-12">Description</label>
                                  <div class="col-sm-12">
                                    {{actualBundle.channels[channelIndex].ChannelData.channelInfo.description}}
                                  </div>
                              </div>

                              <div v-if="actualBundleIsDefaultBundle==false" class="form-group">
                                  <label class="col-xs-12">{{labelAddress[actualLanguage]}}</label>
                                  
                                  <div class="col-sm-12">
                                    {{actualBundle.channels[channelIndex].ChannelData.address}}
                                  </div>
                              </div>
                            </div>


                            <div v-if="actualBundleIsDefaultBundle==false && actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag" class="col-xs-12">
                                <Gmap-Map style="width: 100%; height: 400px;" :zoom="8" :center="center">
                                  <Gmap-Marker v-for="(marker, index) in markers"
                                    :key="index"
                                    :position="marker.position"
                                    :label="marker.label"
                                    :draggable='false'
                                    ></Gmap-Marker>
                                </Gmap-Map>
                            </div>

                          </div>


                          <!-- Bandeau résumé de la période  
                          <div class="row">
                          

                            <div class="col-sm-12 col-md-4">
                                <div class="block block-rounded">
                                  <div class="block-content text-center"> 
                                    <i class="fa fa-bolt fa-3x text-success"></i>
                                    <p><span class="h5 text">{{ labelGraphPeakCurrent[actualLanguage] }}</span></p>
                                    <p class="h4 font-w700">{{actualBundle.channels[channelIndex].ChannelData.peakCurrent | round}} <span class="h4 text">A</span></p>
                                  </div>
                                </div>
                            </div>



                            <div class="col-sm-12 col-md-4">
                                <div class="block block-rounded">
                                  <div class="block-content text-center">
                                    <i class="fa fa-money fa-3x text-success"></i>
                                    <p v-if="actualBundle.channels[channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png'"><span class="h5 text-muted">{{ labelGraphSaving[actualLanguage] }}</span></p>
                                    <p v-else><span class="h5 text-muted">{{ labelGraphCost[actualLanguage] }}</span></p>
                                    <p class="h4 font-w700">{{actualBundle.channels[channelIndex].ChannelData.sumCost | toCurrency }} <span class="h4 text-muted"></span></p>
                                  </div>
                                </div>
                            </div>



                            <div class="col-sm-12 col-md-4">
                                <div class="block block-rounded">
                                  <div class="block-content text-center">
                                    <i class="fa fa-download fa-3x text-success"></i>
                                    <p v-if="actualBundle.channels[channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png'"><span class="h5 text-muted">Production</span></p>
                                    <p v-else><span class="h5 text-muted">{{ labelGraphConsumption[actualLanguage] }}</span></p>
                                    <p class="h4 font-w700">{{actualBundle.channels[channelIndex].ChannelData.sumKwh | round}} <span class="h4 text-muted">kWh</span></p>
                                  </div>
                                </div>
                            </div>

                          </div>

                        </div>
                        -->

                        

                        <!-- Affichage du graphique -->
                        <div v-if="flagDisplayGraph" class="row measurement-graph-row push">
                          <div v-if = "flagDisplayChannelJournal" class="row">

                            <div v-if="thisChannelAsDeviceFlag" class="col-sm-12 col-lg-12">
                              <multiple-graph :channelIndex="channelIndex" ></multiple-graph>
                            </div>

                            <div class="col-sm-12 col-lg-12">
                                <channel-journal :channelIndex="channelIndex" ></channel-journal>
                            </div>

                            <div class="col-sm-12 col-md-12 push">
                              <p><button @click="flagDisplayChannelJournal=false" type="button " class="btn btn-success align-right" name="button"><i class="fa fa-list-alt fa-1x"></i> {{ buttonLabelHideJournal[actualLanguage] }}</button></p>
                            </div>
                          </div>
                          <div v-else class="row">

                            <div v-if="thisChannelAsDeviceFlag" class="col-sm-12">
                              <multiple-graph :channelIndex="channelIndex" ></multiple-graph>
                            </div>

                            <div v-if="actualBundleIsDefaultBundle==false" class="col-sm-12 col-md-12 push">
                              <p><button @click="flagDisplayChannelJournal=true" type="button " class="btn btn-success align-right" name="button"><i class="fa fa-list-alt fa-1x"></i> {{ buttonLabelShowJournal[actualLanguage] }}</button></p>
                            </div>

                          </div>
                        </div>



                          <div class="col-xs-12">


                          </div>
                        
                      </div>


                    
                    </div>
                    <!-- END Static Labels -->
                    
                </div>
                
              </div>

            </div>
        </div>
      </div>
      </div>
    </div>
    
  </div>


</template>

<script>


import _ from 'underscore'
import {mapState, mapGetters,mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import RelativePowerBar from './SubComponents/RelativePowerBar.vue'
import PortGraph from './SubComponents/PortGraph.vue'
import MultipleGraph from './SubComponents/MultipleGraph.vue'
import ChannelJournal from './SubComponents/ChannelJournal.vue'

export default {
  props: ['channelIndex'],
  components: {
    Spinner,
    PortGraph,
    RelativePowerBar,
    MultipleGraph,
    ChannelJournal,
  },

  data() {
    return {
      tempoBundle : {},
      displayDataTable : false,
      flagDisplayChannel : 0,
      flagDisplayGraph : true,
      flagChannelDataIsLoading : true,
      flagDisplayChannelJournal : false,
      flagDisplayPowerBar : true,
      alertShowAddButton: true,
      thisChannelAsDeviceFlag : false,
      channelIsSaving : false,
      channelIsDeleting : false,
      alertIsCreating : false,
      flagCloudLiveIsActivating : false,
      channelReadings : [],
      totalPower : 0,
      peakCurrent : 0,
      totalCost : 0,

      actualBundleIsDefaultBundle : true,
      labelAddress : {FR: 'Adresse', EN: 'Address'},
      center: {lat: 46.82, lng: -71.25},
      markers: [{position: {lat: 46.1,lng: -72.4,},label:"1"}],

      flagDisplayPowerMA : true,
      powerBarDataWk : {Label:'Dernière semaine', PreviousText:'Semaine', Value:10, Max:20, AfterText:' kWh'},
      powerBarDataDay : {Label:'Dernier jour', PreviousText:'Jour', Value:5, Max:20, AfterText:' kWh'},
      powerBarDataHr : {Label:'Dernière heure', PreviousText:'Heure', Value:16, Max:20, AfterText:' kW'},
      powerBarData5Min : {Label:'Dernière mesure', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_001H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_004H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_006H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_012H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_024H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_072H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_168H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_336H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_720H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},


      labelGraphPeakCurrent: {FR: 'Courant maximum', EN: 'Max current'},
      labelGraphCost: {FR: 'Coût', EN: 'Cost'},
      labelGraphSaving: {FR: 'Économies', EN: 'Savings'},
      labelGraphConsumption: {FR: 'Consommation', EN: 'Consumption'},

      labelBarActual : {FR: 'Actuelle', EN: 'Actual'},
      labelBar001H : {FR: 'Moyenne 1Hr', EN: 'Average 1Hr'},
      barLabelLastReading:{FR: "Dernière mesure", EN: 'Last measure'},
      barLabelMA_1Hr:{FR: "Moyenne 1Hr", EN: '1 Hr Average'},
      barLabelMA_4Hr:{FR: "Moyenne 4Hrs", EN: '4 Hrs Average'},
      barLabelMA_6Hr:{FR: "Moyenne 6Hrs", EN: '6 Hrs Average'},
      barLabelMA_12Hr:{FR: "Moyenne 12Hrs", EN: '12 Hrs Average'},
      barLabelMA_1Day:{FR: "Moyenne 1Jr", EN: '1 Day Average'},
      barLabelMA_3Day:{FR: "Moyenne 3Jrs", EN: '3 Days Average'},
      barLabelMA_7Day:{FR: "Moyenne 7Jrs", EN: '7 Days Average'},
      barLabelMA_14Day:{FR: "Moyenne 14Jrs", EN: '14 Days Average'},
      barLabelMA_30Day:{FR: "Moyenne 30Jrs", EN: '30 Days Average'},


      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},

      buttonLabelHideJournal:{FR: "Cacher le journal", EN: 'Hide device log book'},
      buttonLabelShowJournal:{FR: "Afficher le journal", EN: 'Display device log book'},

    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','actualBundleChannelMaximums','displayAllChannelGraphFlag']),
    ...mapState('chargesStore',['startDate', 'endDate']),
    ...mapState('overlayStore', ['overlayParameters']),
  },
  watch: {
    actualBundle(){
        this.reloadTempoBundle()
        this.flagDisplayGraph = false
        //console.log('---DisplayChannel:Watcher Actual Bundle-----')
        this.channelReadings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings
        //console.log('---READINGS-----'+this.channelIndex)
        //console.log(this.channelReadings)
        this.computeChannelOverview()

        this.$nextTick(() => {
          this.flagDisplayGraph = true
        });
        
    },
    displayAllChannelGraphFlag(){
        //console.log('---DisplayChannel:Watcher Display all channel-----')
        if(this.displayAllChannelGraphFlag){
          //this.flagChannelDataIsLoading = false
        }else{
          //this.flagChannelDataIsLoading = true
        }
    },
    actualBundleChannelMaximums(){
      this.flagDisplayPowerBar = false
      this.refreshPowerBar()
      this.flagDisplayPowerBar = true
      //console.log('---DisplayChannel:Actual Bundle Channel Maximums-----')
      //console.log(this.actualBundleChannelMaximums)
      
    },

  },

  methods: {
  ...mapActions('overlayStore', ['showModal']),

   toggleDisplayChannel(){
      this.flagDisplayChannel = ~this.flagDisplayChannel
      //this.checkIfDeviceDataLoaded()
      if(this.flagDisplayChannel){
        this.readChannelReadings()
        }
      else{
        this.actualBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag = false
        this.$store.dispatch('sessionStore/setActualBundle', JSON.parse(JSON.stringify(this.actualBundle)))
      }
      
      
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
        //this.$store.dispatch('devicesStore/reset')
    },

    readChannelReadings(){
        //Ce call effectue une mutation de actualBundle, l'affichage sera donc activé par le watcher
        //de actualBundle.
        this.flagChannelDataIsLoading = true
        var requestData = { 'postAction':'GetBundleChannelReadings',
                            'bundleId':this.actualBundle.bundle_id,
                            'channelList':[{'channelData':this.actualBundle.channels[this.channelIndex].ChannelData,
                                            'channelBundleIndex':this.channelIndex}],
                            'start':this.startDate,
                            'end':this.endDate,
                            'dataType':'Automatic',
                            }

        this.$store.dispatch('sessionStore/postBundleReadChannelReadings', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.channelReadings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings
                this.computeChannelOverview()
                this.flagChannelDataIsLoading = false
                }
                else{ window.alert("L'enregistrement a échoué. / Saving fail." )}
            }) 
    },


    computeChannelOverview(){
      this.totalCost = 0
      this.totalPower = 0
      this.peakCurrent = 0

      for (let j = 0; j < this.channelReadings.length;j++){
          this.totalCost  =this.totalCost + this.channelReadings[j].cost
          this.totalPower = this.totalPower + this.channelReadings[j].kwr
          if(this.channelReadings[j].peakCurrent >this.peakCurrent){this.peakCurrent = this.channelReadings[j].peakCurrent }
      }

    },


    refreshPowerBar(){

        //console.log('Refresh Power Bar:' + this.channelIndex)
        //{'5min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0}
        this.powerBarData5Min = {Label:this.barLabelLastReading[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['5min'],
                                Max:this.actualBundleChannelMaximums['5min'],
                                AfterText:' W'}

        this.powerBarDataMA_001H = {Label:this.barLabelMA_1Hr[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_001H'],
                                Max:this.actualBundleChannelMaximums['MA_001H'],
                                AfterText:' W'}

        this.powerBarDataMA_004H = {Label:this.barLabelMA_4Hr[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_004H'],
                                Max:this.actualBundleChannelMaximums['MA_004H'],
                                AfterText:' W'}

        this.powerBarDataMA_006H = {Label:this.barLabelMA_6Hr[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_006H'],
                                Max:this.actualBundleChannelMaximums['MA_006H'],
                                AfterText:' W'}

        this.powerBarDataMA_012H = {Label:this.barLabelMA_12Hr[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_012H'],
                                Max:this.actualBundleChannelMaximums['MA_012H'],
                                AfterText:' W'}

        this.powerBarDataMA_024H = {Label:this.barLabelMA_1Day[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_024H'],
                                Max:this.actualBundleChannelMaximums['MA_024H'],
                                AfterText:' W'}

        this.powerBarDataMA_072H = {Label:this.barLabelMA_3Day[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_072H'],
                                Max:this.actualBundleChannelMaximums['MA_072H'],
                                AfterText:' W'}

        this.powerBarDataMA_168H = {Label:this.barLabelMA_7Day[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_168H'],
                                Max:this.actualBundleChannelMaximums['MA_168H'],
                                AfterText:' W'}

        this.powerBarDataMA_336H = {Label:this.barLabelMA_14Day[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_336H'],
                                Max:this.actualBundleChannelMaximums['MA_336H'],
                                AfterText:' W'}

        this.powerBarDataMA_720H = {Label:this.barLabelMA_30Day[this.actualLanguage],
                                PreviousText:'',
                                Value:this.actualBundle.channels[this.channelIndex].ChannelData.lastMeasure['MA_720H'],
                                Max:this.actualBundleChannelMaximums['MA_720H'],
                                AfterText:' W'}


    //{'5min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0}
    },


    loadCloudLive(){
      
      this.flagCloudLiveIsActivating = true
      var requestData = { 'postAction':'EnableDeviceLiveCloudReadings',
                        'deviceId': this.actualBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId,
                    }
      this.$store.dispatch('sessionStore/postDevice', requestData)
          .then((response) => {
          //response.data.Code='OK'
          this.flagCloudLiveIsActivating = false
          if(response.data.Code=='OK'){
                var modalParameters = {
                            'liveType':'Channel',
                            'channelIndex':this.channelIndex,
                            'channelId':this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
                            'deviceId':this.actualBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId,
                                  }
                                  
                this.$store.dispatch('overlayStore/setParameters',modalParameters)
                this.showModal('channel-cloud-live-modal-display')                
              }
              else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
          })  
    },


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    
    //markers: [{position: {lat: 46.1,lng: -72.4,},label:"1"}],
    this.markers[0].position.lat = this.actualBundle.channels[this.channelIndex].ChannelData.position.latitude
    this.markers[0].position.lng = this.actualBundle.channels[this.channelIndex].ChannelData.position.longitude
    this.markers[0].position.label = this.channelIndex




    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}

    this.refreshPowerBar()

  },


  beforeMount(){
    this.reloadTempoBundle()
    this.refreshPowerBar()
    //console.log('---TEMPO BUNDLE----')
    //console.log(this.tempoBundle.channels[this.channelIndex])
    //console.log(this.tempoBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag)
    //console.log('---DisplayChannel: Mount: index:' +this.channelIndex)
    this.actualBundleIsDefaultBundle = this.actualBundle.bundle_id.includes('DefaultGroup::DefaultBundle')

    this.thisChannelAsDeviceFlag = this.tempoBundle.channels[this.channelIndex].ChannelData.linkedDevicePorts.deviceId != "TBD"

    if(this.tempoBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag){
      this.flagDisplayChannel = -1
      this.flagChannelDataIsLoading = false
      this.channelReadings = this.tempoBundle.channels[this.channelIndex].ChannelData.Readings
      }


  

  }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// DisplayChannel.vue?5df0f27a